import { Clientes, HeaderPDF, ItensVendas, VendasRelatorio } from '../../../Utils/Types'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Funcoes } from '../../../Utils/Funcoes'
import moment from 'moment'

export class ReportItensPeriodoPDF {

    private relItensPeriodo: ItensVendas[]
    private headers: HeaderPDF[]
    private corpoDocumento: any
    private body: any
    private dadosEmpresa: any
    private datai: any
    private dataf: any


    constructor(relItensPeriodo: ItensVendas[], headers: HeaderPDF[], datai: string, dataf: string) {
        this.relItensPeriodo = relItensPeriodo;
        this.headers = headers;
        this.datai = datai ? moment(datai).format('DD/MM/YYYY') : datai
        this.dataf = dataf ? moment(dataf).format('DD/MM/YYYY') : dataf

        this.body = [];
    }


    async GerarPDF(relItensPeriodo: ItensVendas[]) {

        this.dadosEmpresa = Funcoes.GetDadosEmpresa()

        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        let dados = relItensPeriodo.map((item: any) => {
            return [
                { text: item.id, alignment: 'left', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                { text: item.desc_prod , alignment: 'left', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                { text: item.qtde, alignment: 'left', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                { text: Funcoes.numberFormat(item.vl_unit, 'currency') ||  Funcoes.numberFormat(0 , 'currency'), alignment: 'left', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                { text: Funcoes.numberFormat(item.vl_tot, 'currency') ||  Funcoes.numberFormat(0 , 'currency'), alignment: 'left', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                { text: Funcoes.numberFormat(item.vl_desc || 0, 'currency') ||  Funcoes.numberFormat(0 , 'currency'), alignment: 'right', fontSize: 8, margin: [0, 2, 0, 2], border: [false, true, false, false], },
                ];
        });

        const footer = (currentPage: number, pageCount: number,) => {
            return [
                {
                    layout: 'Borders',
                    style: 'tableExample',
                    margin: [50, 0, 50, 50],
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: [
                            [
                                { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                                { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },

                            ],
                        ]
                    }
                },
            ]
        };

        const docDefinitions: any = {
            pageSize: 'A4',
            pageMargins: [50, 0, 50, 50],
            content: [

                {
                    layout: 'Borders',
                    style: 'tableExample',
                    table: {
                        headerRows: 1,
                        widths: ['*'],
                        body: [
                            [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                            [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                            [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                            [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                        ],
                    },
                },

                {
                    //[left, top, right, bottom]
                    layout: 'noBorders',
                    style: 'tableExample',
                    table: {
                        widths: ['100%'],
                        body: [
                            [{ text: 'Relatório de Vendas', alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] }],
                        ],

                    },

                },

                this.datai !== '' || this.dataf !== '' ?
                    {
                        //[left, top, right, bottom]
                        layout: 'Borders',
                        style: 'tableExample',
                        table: {
                            widths: ['100%'],
                            body: [
                                [{ text: 'Filtros Do Relatório: ', bold: true, margin: [0, 0, 0, 0], fontSize: 10, border: [false, true, false, false] }],

                            ],

                        },

                    } : null,

                {
                    layout: 'noBorders',
                    style: 'tableExample',
                    margin: [0, 0, 0, 0],
                    table: {
                        body: [
                            [
                                this.datai !== '' ?
                                    {
                                        text: [
                                            { text: 'Período: ', fontSize: 9 },
                                            { text: this.datai, fontSize: 10, bold: true },
                                            { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                                            { text: this.dataf, fontSize: 10, bold: true }
                                        ],
                                        margin: [0, 0, 0, 0]
                                    } : null,

                            ],
                        ],
                    },
                },

                {
                    layout: 'Borders',
                    style: 'tableExample',
                    table: {
                        //[left, top, right, bottom]
                        widths: ['10%', '40%', '15%', '12%', '11%', '12%'],
                        body: [
                            [
                                { text: 'Venda', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                                { text: 'Descrição', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                                { text: 'Qtd. Itens', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                                { text: 'Unitário', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                                { text: 'Total', alignment: 'left', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                                { text: 'Desconto', alignment: 'right', fontSize: 10, margin: [0, 4, 0, 4], border: [false, true, false, false], bold: true },
                            ],
                        ],
                    },
                },
                {
                    layout: 'Borders',
                    style: 'tableExample',
                    margin: [0, 0, 0, 0],
                    table: {
                        widths: ['10%', '40%', '15%', '12%', '11%', '12%'],
                        body: dados
                    },
                }

            ].filter(Boolean),

            footer: footer
        };

        pdfMake.createPdf(docDefinitions).print();

    }

}